/* eslint-disable */
export default {
  121: 'Active',
  123: 'Deleted',
  8: 'Suspended',
  124: 'UserPaused',
  126: 'BudgetPaused',
  127: 'BudgetUserPaused'
};

